import { DEFAULT_PAGE_SIZE_XL } from "@/const";
import {
  GridFilterModel,
  GridPaginationModel,
  GridSortModel,
} from "@mui/x-data-grid";
import { create } from "zustand";

type PromptsDatagridState = {
  paginationModel: GridPaginationModel;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
};

type PromptsDatagridActions = {
  setPaginationModel: (model: GridPaginationModel) => void;
  setSortModel: (model: GridSortModel) => void;
  setFilterModel: (model: GridFilterModel) => void;
};

export const usePromptsDatagridStore = create<
  PromptsDatagridState & PromptsDatagridActions
>((set) => ({
  paginationModel: { page: 0, pageSize: DEFAULT_PAGE_SIZE_XL },
  sortModel: [],
  filterModel: { items: [] },
  setPaginationModel: (model) => set({ paginationModel: model }),
  setSortModel: (model) => set({ sortModel: model }),
  setFilterModel: (model) => set({ filterModel: model }),
}));
